// extracted by mini-css-extract-plugin
export default {"linkList":"CategoryListingLinks_linkList__CwQ2e","header":"CategoryListingLinks_header__hZaPm"};